export default "__VITE_ASSET__ihUWR0vH__"